(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider

            .state('BlogList', {
                url: "/:langcode/blog{dummyParam:any}?p?q",
                templateUrl: './app/blog/blog-list.html',
                controller: "BlogListController",
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blog');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],


                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }],

                    title: ['$translate', function ($translate) {
                        return $translate('c_blog_title').then(function (res) {
                            return res;
                        });
                    }],

                    description: ['$translate', function ($translate) {
                        return $translate('c_blog_desc').then(function (res) {
                            return res;
                        });
                    }]
                },
                metaTags: {
                    title: '{{title}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg'
                    }
                }
            })


            .state('blogKategori', {
                url: '/:langcode/blog/c/:kategori?p?q',
                templateUrl: './app/blog/blog-list.html',
                controller: "BlogListController",
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blog');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],

                    titleAdres: ['getCat', '$translate', function (getCat, $translate) {
                        if (getCat)
                            for (var i = 0; i < getCat.length; i++) {
                                if (getCat[i].selected)
                                    return getCat[i].name;
                            }
                        else
                            return $translate.instant('c_blog_title');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }],
                    // title: function ($translate) {
                    //     return $translate('c_blog_title').then(function (res) {
                    //         return res;
                    //     });
                    // },

                    description: ['$translate', function ($translate) {
                        return $translate('c_blog_desc').then(function (res) {
                            return res;
                        });
                    }]
                },
                metaTags: {
                    title: '{{titleAdres}}',
                    description: '{{description}}',
                    properties: {
                        'og:image': 'http://www.endeksa.com/share3.jpg',
                        'og:image:secure_url': 'https://www.endeksa.com/share3.jpg'
                    }
                }
            })

            .state('blogDuzenle', {
                url: '/:langcode/blog/edit/:name',
                templateUrl: 'app/blog/blog-edit.html',
                controller: 'BlogEditController',
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blogEditor');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    guard: ['guardSvc', function (guardSvc) {
                        return guardSvc.guardRouteRole([20, 50, 40]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                }

            })

            .state('blogEkle', {
                url: '/:langcode/blog/add/',
                templateUrl: 'app/blog/blog-edit.html',
                controller: 'BlogEditController',
                controllerAs: "vm",
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'blogEditor');
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    guard: ['guardSvc', function (guardSvc) {
                        return guardSvc.guardRouteRole([20, 50, 40]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                }

            })

            .state('blogDetail', {
                url: "/:langcode/blog/{path:article|yazi|artigo|articulo}/:name",
                templateUrl: './app/blog/blog-detail.html',
                controller: "BlogDetailController",
                controllerAs: "vm",
                params: {
                    path: ['$translate', function ($translate) {
                        return $translate.instant("blogDetail");
                    }],
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        var bundles = ['blogDetail'];
                        return lazyLoadSvc.load($transition$, bundles);
                    }],

                    LangProtect: ['routeHelpers', function (routeHelpers) {
                        return routeHelpers.langProtect();
                    }],

                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],
                    getCat: ['blog_factory', '$transition$', function (blog_factory, $transition$) {
                        var gtc = blog_factory.category_list({ language: window.langCode() });
                        return gtc.$promise.then(function (response) {
                            var categories = [];
                            angular.forEach(response.data, function (file, key) {
                                if (file.details.length) {
                                    var kat = { name: file.details[0].name, url: file.details[0].slug, selected: $transition$.params().kategori === file.details[0].slug };
                                    categories.push(kat);
                                }
                            });

                            return categories;

                        }, function () {
                            return null;
                        });
                    }],
                    blogPost: ['blog_factory', '$transition$', '$translate', '$timeout', '$rootScope', '$q', function (blog_factory, $transition$, $translate, $timeout, $rootScope, $q) {
                        var blogDetay = blog_factory.get({ name: $transition$.params().name, language: window.langCode() });
                        var deferred = $q.defer();
                        blogDetay.$promise.then(
                            function (resp) {
                                if (resp) {
                                    if (resp.statusCode === 301) {
                                        $timeout(function () {
                                            $rootScope.MetaTags.prerender.statusCode = 301;
                                            window.redirected = "Location: " + $transition$.router.stateService.href("blogDetail", { langcode: $transition$.params().langcode, name: resp.redirectToActionActiveSlug, path: $translate.instant("blogDetail") });
                                            $rootScope.MetaTags.prerender.header = window.redirected;
                                        });
                                        $transition$.abort();
                                        $transition$.router.stateService.go("blogDetail", { langcode: $transition$.params().langcode, name: resp.redirectToActionActiveSlug, path: $translate.instant("blogDetail") });
                                        deferred.resolve();
                                    }
                                    else {
                                        if (resp.urlHistory && resp.urlHistory.length)
                                            window.blogUrls = resp.urlHistory.filter(m => m.isActive);

                                        if (!resp || !resp.details.length) {
                                            $transition$.abort();
                                            $transition$.router.stateService.go("BlogList", { langcode: $transition$.params().langcode });
                                        }
                                        deferred.resolve(resp);
                                    }
                                } else {
                                    $translate('c_blog1').then(function (res) {
                                        deferred.resolve(res);
                                    });
                                }
                            },
                            function (rej) {
                                // if (rej.status === 404) {
                                $translate('c_blog2').then(function (res) {
                                    deferred.resolve(res);
                                });
                                // } else {
                                //     $translate('c_blog1').then(function (res) {
                                //         deferred.resolve(res);
                                //     });
                                // }
                            });

                        return deferred.promise;
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('blog');
                        return $translate.refresh();
                    }]
                },
                metaTags: {

                    title: ['blogPost', function (blogPost) {
                        return blogPost.details && blogPost.details[0].title;
                    }],

                    description: ['blogPost', function (blogPost) {
                        return blogPost.details && blogPost.details[0].metaDescription;
                    }],
                    prerender: {

                        statusCode: ['blogPost', function (blogPost) {
                            return blogPost.details ? 200 : 302;
                        }],

                        header: ['blogPost', function (blogPost) {
                            return blogPost.details ? null : 'Location: https://www.endeksa.com/blog';
                        }]
                    },
                    properties: {
                        // 'og:image': ['blogPost', function (blogPost) {
                        //     return blogPost.OneCikanResimPath.replace('https', 'http');
                        // }],
                        'og:image': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].featuredPhoto.replace('https://', 'http://');
                        }],
                        'og:image:secure_url': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].featuredPhoto.replace('http://', 'https://');
                        }],
                        // 'og:image:type': 'image/jpeg',
                        'fb:admins': '504791212',
                        'og:type': 'article',
                        'article:published_time': '{{blogPost.createDate}}',
                        'article:tag': ['blogPost', function (blogPost) {
                            return blogPost.details && blogPost.details[0].metas;
                        }]
                    }
                }
            });

    }]);

})();
